import { Heart } from "lucide-react";
import { IMAGES } from "@/data";

export const FamilyBand = () => {
  return (
    <section id="family" className="relative overflow-hidden bg-ink">
      <div className="absolute inset-0">
        <img
          src={IMAGES.realFamily}
          alt="The family behind ClearCo Window Cleaning"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-28 md:py-36">
        <div className="max-w-xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand">
            <Heart size={14} strokeWidth={2} /> Our promise
          </div>
          <h2 className="mt-6 font-display font-extrabold text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Family owned &<br />operated
          </h2>
          <p className="mt-6 text-lg text-slate-300 leading-relaxed">
            ClearCo isn't a faceless franchise — we're a local family who takes pride in every window we touch. Choosing us means friendly, trustworthy service and results we'd be proud to show our own family.
          </p>
        </div>
      </div>
    </section>
  );
};
